<template>
  <div class="modal fade" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-capitalize" id="exampleModalLongTitle">
            Edit stall details{{ unit && unit.unitNo ? ` for Stall ${unit.unitNo}` : '' }}
          </h5>
          <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-3">
              <label>Stall Number</label>
              <input v-model="editData.unitNo" type="text" class="form-control" placeholder="Stall Name">
            </div>

            <div class="col-12 mb-3">
              <label>Stall Type</label>
              <select class="form-select" v-model="editData.category">
                <option value="">Select Category</option>
                <option v-for="(item, index) in unitCategories" :key="`${index}`" :value="item.category">
                  {{ item.category }}
                </option>
              </select>
            </div>

            <div class="col-12 mb-3">
              <label>Monthly Rent</label>
              <input v-model="editData.monthlyRent" type="text" class="form-control" placeholder="Enter amount">
            </div>

            <div class="col-12 mb-3">
              <label>Arrears</label>
              <input v-model="editData.arrears" type="text" class="form-control" placeholder="Enter arrears amount">
            </div>

            <div class="col-12 mb-3">
              <label>Occupants</label>
              <input v-model="editData.occupants" type="text" class="form-control" placeholder="Occupants">
            </div>

            <div class="col-12 mb-3">
              <label>Phone Number</label>
              <input v-model="editData.phoneNumber" type="text" class="form-control" placeholder="Phone Number">
            </div>

            <div class="col-12 mb-3">
              <label>ID Number</label>
              <input v-model="editData.idNo" type="text" class="form-control" placeholder="ID Number">
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
          <button
              @click="updateUnit"
              type="button"
              class="btn btn-success text-uppercase"
              :disabled="updating"
          >
            <span v-if="updating">
              <span class="spinner-border spinner-border-sm me-2" role="status"></span>
              Saving...
            </span>
            <span v-else>
              <i class="bx bx-save font-size-16"></i>
              <span class="pl-1 d-md-inline">Save Changes</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { execute, rent } from "@/api";

export default {
  name: "EditUnitModal",
  props: {
    modalId: {
      type: String,
      default: "edit-unit-modal"
    },
    unit: {
      type: Object,
      default: () => ({
        id: null,
        unitNo: '',
        category: '',
        monthlyRent: '',
        arrears: '',
        occupants: '',
        phoneNumber: '',
        idNo: ''
      })
    },
    unitCategories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      updating: false,
      editData: {
        id: null,
        unitNo: '',
        category: '',
        monthlyRent: '',
        arrears: '',
        occupants: '',
        phoneNumber: '',
        idNo: ''
      }
    };
  },
  watch: {
    unit: {
      handler(newVal) {
        if (newVal) {
          this.editData = {
            id: newVal.id || null,
            unitNo: newVal.unitNo || '',
            category: newVal.category || '',
            monthlyRent: newVal.monthlyRent || '',
            arrears: newVal.arrears || '',
            occupants: newVal.occupants || '',
            phoneNumber: newVal.phoneNumber || '',
            idNo: newVal.idNo || ''
          };
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateUnit() {
      if (!this.editData.unitNo) {
        alert("Unit number is required");
        return;
      }

      this.updating = true;

      // Create a copy of unit data with updated fields
      const updatedUnit = Object.assign({}, this.unit, this.editData);

      const data = new FormData();
      data.append("function", "updateUnits");
      data.append("unit", JSON.stringify(updatedUnit));
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, rent)
          .then((res) => {
            this.updating = false;
            if (res.data.success) {
              alert("Unit updated successfully!");
              this.$emit('unit-updated');

              // Close modal
              const modalElement = document.getElementById(this.modalId);
              const modal = window.bootstrap.Modal.getInstance(modalElement);
              if (modal) modal.hide();
            } else {
              alert(res.data.message || "Failed to update unit");
            }
          })
          .catch((e) => {
            this.updating = false;
            alert("Error: " + e.message);
          });
    }
  }
};
</script>